"use strict"

import React from "react"

import { isLTPM, getDate } from "../../../components/shared_components_registration"
import { RunInfoPopover } from "../../../components/shared_components_registration_overflow"
import LabelingCompleteLabel from "../../graphing/plotting/widgets/ToggleRunLabelsButton/LabelingCompleteLabel"

const registration = {
  get_live_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.live" }) : "LIVE"),
  get_site_label: (intl) => (isLTPM ? "" : "Site"),
  get_reactor_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.reactor" }) : "Reactor"),
  get_run_identifier_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.run.identifier" }) : "Run Identifier",
  get_inoculation_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "fermmanagement.inoculated.on" }) : "Inoculated On",
  get_last_loaded_label: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "livedash.data.last.loaded",
        })
      : "Data Last Loaded",
  get_latest_label: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "fermmanagement.latest.data",
        })
      : "Latest Data",
  get_day_label: (intl) =>
    isLTPM
      ? intl.formatMessage({
          id: "graphing.timelabel.day",
        })
      : "Day",
}

export default function RunInfoHeader({ runData, intl }) {
  const {
    site,
    reactor,
    name,
    inoculated_on,
    finished_on,
    observation_max,
    observation_max_day,
    loadedTime,
  } = runData

  const supplementDate =
    observation_max && observation_max_day
      ? `${getDate(observation_max, null, true)} (${registration.get_day_label(
          intl,
        )}: ${observation_max_day.toFixed(3)})`
      : "???"

  return (
    <div style={{ display: "flex" }}>
      <RunInfoPopover run={runData} intl={intl} />
      &nbsp;&nbsp;
      <h2 style={{ margin: "0", display: "flex" }}>
        {site && (
          <>
            <span title={registration.get_site_label(intl)}>{site}</span>&mdash;
          </>
        )}
        <span title={registration.get_reactor_label(intl)}>{reactor}</span>
        {name ? (
          <>
            &mdash;<span title={registration.get_run_identifier_label(intl)}>{name}</span>
          </>
        ) : inoculated_on ? (
          <>
            &mdash;
            <span title={registration.get_inoculation_label(intl)}>{getDate(inoculated_on, null, true)}</span>
          </>
        ) : null}
        {finished_on ? null : (
          <span
            className="bordered single-run-live-label"
            style={{ alignSelf: "flex-start" }}
            title={`${registration.get_last_loaded_label(intl)}: ${getDate(
              loadedTime,
              null,
              true,
            )}\n${registration.get_latest_label(intl)}: ${supplementDate}`}
          >
            {registration.get_live_label(intl)}
          </span>
        )}
        <LabelingCompleteLabel
          run={runData}
          customStyle={{
            display: "inline-block",
            padding: "3px",
            fontSize: "40%",
            verticalAlign: "super",
          }}
        />
      </h2>
      &nbsp;
    </div>
  )
}
